'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reduxImmutable = require('redux-immutable');

var _editorStateReducer = require('./editorStateReducer');

var _editorStateReducer2 = _interopRequireDefault(_editorStateReducer);

var _editorIdReducer = require('./editorIdReducer');

var _editorIdReducer2 = _interopRequireDefault(_editorIdReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Reducers
exports.default = (0, _reduxImmutable.combineReducers)({
    editorState: _editorStateReducer2.default,
    editorId: _editorIdReducer2.default
}); // Lib


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/store/reducers/index.js
// module id = 1753
// module chunks = 0